import React, {Component} from 'react';
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { renderField, renderCheckbox, required, renderTextArea, json } from "../../../utils/formValidations.js";
import { withRouter } from "react-router-dom";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter, Collapse, Alert } from "reactstrap";
import Proptypes from "prop-types";
import { NotificationManager } from "react-notifications";
import {getUrlFilterPolicies , getUrlFilterCategories, getSafeSearchPatterns} from "../../../actions/actionFilters";
import { getLicenseStatus} from "../../../actions/actionFooter";

class UrlFilterFormTemplate extends Component {
    constructor (props){
        super(props);
        this.state = {
            currentFilter: {},
            collapseAdvanced: false,
            licensed: false,
        };
        this.submitApi = this.submitApi.bind(this);
        this.handleCreateSuccess = this.handleCreateSuccess.bind(this);
        this.handleCreateError = this.handleCreateError.bind(this);
        this.handleUpdateError = this.handleUpdateError.bind(this);
        this.handleUpdateSuccess = this.handleUpdateSuccess.bind(this);
        this.toggleAdvanced = this.toggleAdvanced.bind(this);
    }

    toggleAdvanced() {
        this.setState({collapseAdvanced: !this.state.collapseAdvanced})
    }



    submitApi(userData) {
        if (!userData.categories){
            userData.categories = {};
        }
        if (this.props.fromUpdate) {
            userData.filter_policy_id = this.state.currentFilter && this.state.currentFilter.filter_policy_id;
            this.props.updateUrlFilterPolicy(userData)
                .then(() => this.handleUpdateSuccess())
                .catch(() => this.handleUpdateError());
        }else {
            this.props.createUrlFilterPolicy(userData)
                .then(() => this.handleCreateSuccess())
                .catch(() => this.handleCreateError());
        }
    }

    handleUpdateSuccess(){
        const {updateFilterError} = this.props;
        if(updateFilterError){
            NotificationManager.error(updateFilterError,"Update Filter", 3000);
        }
        else{
            NotificationManager.success("Filter Updated", "Successfully Updated Web Filter Policy");
            this.props.history.push("/webfilter");
        }
    }

    handleUpdateError(){
        const {updateFilterError} = this.props;
        if(updateFilterError){
            NotificationManager.error(updateFilterError,"Update Filter", 3000);
        } else
            NotificationManager.error("Update Web Filter Failed", "Update Filter", 3000);
    }

    handleCreateSuccess(){
        const {createFilterError} = this.props;
        if(createFilterError){
            NotificationManager.error(createFilterError,"Create Filter", 3000);
        }
        else{
            NotificationManager.success("Filter Created", "Successfully Created Filter");
            this.props.history.push("/webfilter");
        }
    }

    handleCreateError(){
        const {createFilterError} = this.props;
        if(createFilterError){
            NotificationManager.error(createFilterError,"Create Filter", 3000);
        } else
            NotificationManager.error("Create Filter Failed","Create Filter", 3000);
    }

    cancelButton(){
        this.props.history.push("/webfilter");
    }


    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.filters && nextProps.filters.length > 0 && this.props.filters !== nextProps.filters && this.props.getFilterLoading && this.props.fromUpdate){
            let currentFilter = nextProps.filters.find(filter => filter.filter_policy_id === this.props.filterPolicyId);
            this.setState({currentFilter: currentFilter});
            this.props.initialize({
                filter_policy_name: currentFilter.filter_policy_name,
                filter_policy_descriptions: currentFilter.filter_policy_descriptions,
                domain_blacklist: currentFilter.domain_blacklist ? currentFilter.domain_blacklist.join('\n') : '',
                domain_whitelist: currentFilter.domain_whitelist ? currentFilter.domain_whitelist.join('\n') : '',
                ssl_bypass_domains: currentFilter.ssl_bypass_domains ? currentFilter.ssl_bypass_domains.join('\n') : '',
                ssl_bypass_ips: currentFilter.ssl_bypass_ips ? currentFilter.ssl_bypass_ips.join('\n') : '',
                categories: currentFilter.categories,
                deny_by_default: currentFilter.deny_by_default,
                enable_categorization: currentFilter.enable_categorization,
                enable_safe_search: currentFilter.enable_safe_search,
                disable_logging: currentFilter.disable_logging,
                safe_search_patterns: currentFilter.safe_search_patterns ? JSON.stringify(currentFilter.safe_search_patterns, undefined, 4) : '[]',
            });
            if ((currentFilter.ssl_bypass_ips && currentFilter.ssl_bypass_ips.length > 0 )  ||
                currentFilter.ssl_bypass_domains && currentFilter.ssl_bypass_domains.length > 0){
                this.toggleAdvanced()
            }
        }
    }

    componentDidMount() {
        this.props.getUrlFilterCategories();

        if (this.props.fromUpdate) {
            this.props.getUrlFilterPolicies();
        }
        else{
            this.props.getSafeSearchPatterns().then((res) => {
                if (res.response && res.response.safe_search_patterns)
                {
                    this.props.initialize({safe_search_patterns: JSON.stringify(res.response.safe_search_patterns, undefined, 4)})
                }
            });

        }
        this.props.getLicenseStatus()
            .then(() => {
                const {license_info} = this.props;
                if (license_info && license_info.status && license_info.status.features && license_info.status.features.indexOf('url_categorization') >= 0 ){
                    this.setState({licensed: true});
                }
            });
    }

    create_categories(data){
        if (data.length > 0) {
            return data.map(function (category, keyIndex) {
                let name = "categories." + category.id;
                return (
                    <FormGroup key={name}>
                        <Row>
                            <Col sm="6">
                                <Label htmlFor={category.id}>{category.label}</Label>
                            </Col>

                            <Col sm="6">
                                <Field type="name"
                                       name={name}
                                       id={category.id}
                                       component="select"
                                       clearable={false}>
                                    <option value="inherit">Inherit</option>
                                    <option value="allow">Allow</option>
                                    <option value="deny">Deny</option>
                                </Field>
                            </Col>
                        </Row>
                    </FormGroup>
                )
            })
        }
    }
    all_categories(categories) {

        return (
            <div>
                 <Row>
                    <Col sm="4">
                        <Label className="form-group">URL Categories</Label>
                    </Col>
                 </Row>
                <div className="categories_selection">
                    <React.Fragment>
                        {this.create_categories(categories)}
                    </React.Fragment>
                </div>
            </div>

        );
    }

    license_check() {

        if (!this.state.licensed){
            let license_url = `${__LICENSE_INFO_URL__}`;
            return (
                <Alert color="none" isOpen={true}>
                    <h4>Unavailable</h4>
                    This feature must be licensed.
                    <hr />
                    <a href={license_url}>More Information</a><br/>
                </Alert>
            )
        }
    }


    render() {
        const {handleSubmit, categories, has_categorization_enabled} = this.props;
        const deny_by_default_checked = false;
        const enable_categorization_checked = false;
        const enable_safe_search_checked = false;
        const disable_logging_checked = false;

        return (
            <Form onSubmit={handleSubmit(this.submitApi)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="name" className="requiredasterisk">Name</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="filter_policy_name"
                                       id="filter_policy_name"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="filter_policy_descriptions">Description</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="filter_policy_descriptions"
                                       id="filter_policy_descriptions"
                                       component={renderField}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="deny_by_default">Deny By Default</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="checkbox"
                                       name="deny_by_default"
                                       id="deny_by_default"
                                       checked = {deny_by_default_checked}
                                       component={renderCheckbox}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="domain_blacklist">Domain Blacklist (One Per Line)</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="textarea"
                                       name="domain_blacklist"
                                       id="domain_blacklist"
                                       component={renderTextArea}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="domain_whitelist">Domain Whitelist (One Per Line)</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="textarea"
                                       name="domain_whitelist"
                                       id="domain_whitelist"
                                       component={renderTextArea}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="disable_logging">Disable Logging</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="checkbox"
                                       name="disable_logging"
                                       id="disable_logging"
                                       checked = {disable_logging_checked}
                                       component={renderCheckbox}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="enable_safe_search">Enable Safe Search</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="checkbox"
                                       name="enable_safe_search"
                                       id="enable_safe_search"
                                       checked = {enable_safe_search_checked}
                                       component={renderCheckbox}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="enable_categorization">Enable Categorization</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="checkbox"
                                       name="enable_categorization"
                                       id="enable_categorization"
                                       checked = {enable_categorization_checked}
                                       component={renderCheckbox}/>
                            </Col>
                        </Row>
                    </FormGroup>
                    { has_categorization_enabled && categories &&
                        this.license_check()
                    }
                    { has_categorization_enabled && categories && this.state.licensed &&
                        this.all_categories(categories)
                    }

                    <a onClick={this.toggleAdvanced}>
                        <strong>Advanced</strong>
                        <span className="float-right">
                                {this.state.collapseAdvanced ? <i className="fa fa-chevron-down"/> :
                                    <i className="fa fa-chevron-up"/>}
                            </span>
                    </a>
                    <Collapse isOpen={this.state.collapseAdvanced}>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="safe_search_patterns">Safe Search Patterns</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="textarea"
                                       name="safe_search_patterns"
                                       id="safe_search_patterns"
                                       component={renderTextArea}
                                       validate={json}
                                       value="dsfsfdsdf"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col>
                                    <Label htmlFor="ssl_bypass_domains">SSL Bypass Domains (One Per Line)</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field type="textarea"
                                           name="ssl_bypass_domains"
                                           id="ssl_bypass_domains"
                                           component={renderTextArea}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col>
                                    <Label htmlFor="ssl_bypass_ips">SSL Bypass IPs (One Per Line)</Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Field type="textarea"
                                           name="ssl_bypass_ips"
                                           id="ssl_bypass_ips"
                                           component={renderTextArea}
                                    />
                                </Col>
                            </Row>
                    </FormGroup>
                    </Collapse>

                </CardBody>
                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button type="cancel" 
                        className="cancel-button"
                        size="sm" color="basic" onClick={() => this.cancelButton()}> Cancel</Button>
                        <Button type="submit" 
                        className="submit-button"
                        size="sm" color="primary"> Submit</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
        );
    }
}

UrlFilterFormTemplate.proptypes = {
    createUrlFilterPolicy: Proptypes.func,
    updateUrlFilterPolicy: Proptypes.func,
    fromUpdate: Proptypes.bool,
};

let UrlFilterFormWithRouter = withRouter(UrlFilterFormTemplate);


const selector = formValueSelector('UrlFilterForm');

let UrlFilterForm =  connect(state =>{

            const has_categorization_enabled = selector(state, 'enable_categorization');

            return {
                has_categorization_enabled,
                createFilterError: state.filter.createFilterError,
                createFilterLoading: state.filter.createFilterLoading,
                createdFilter: state.filter.createdFilter,
                updateFilterError: state.filter.updateFilterError,
                updateFilterLoading: state.filter.updateFilterLoading,
                updatedFilter: state.filter.updatedFilter,
                filters: state.filter.filters,
                categories: state.filter.categories || [],
                patterns: state.filter.patterns || [],
                getFilterLoading: state.filter.getFilterLoading || false,
                getSafeSearchPatternsLoading: state.filter.getSafeSearchPatternsLoading || false,
                license_info: state.footer && state.footer.license_info ? state.footer.license_info : null,
            }
    },

    dispatch =>
        ({
            getUrlFilterPolicies: () => dispatch(getUrlFilterPolicies()),
            getUrlFilterCategories: () => dispatch(getUrlFilterCategories()),
            getSafeSearchPatterns: () => dispatch(getSafeSearchPatterns()),
            getLicenseStatus: () => dispatch(getLicenseStatus()),
        }))(UrlFilterFormWithRouter);

export default reduxForm({
    form: "UrlFilterForm",
})(UrlFilterForm);